const faqItems = [
  {
    q: '51吃瓜大赛是一个什么样的平台？',
    a: '51吃瓜大赛是专注于网红爆料与明星八卦的深度内容平台，覆盖台北娜娜、莫里秀、玩偶姐姐等数百位热门人物，每日更新最新吃瓜资讯，提供从实时快讯到深度调查的全方位吃瓜体验。',
  },
  {
    q: '如何向51吃瓜大赛投稿爆料？',
    a: '你可以通过页面上的投稿爆料入口发送邮件至 tougao@51chigua.example.com，我们严格保护爆料人隐私，支持匿名投稿。所有爆料线索都会经过编辑团队核实后发布。',
  },
  {
    q: '51吃瓜大赛的内容多久更新一次？',
    a: '我们的内容团队7×24小时不间断工作，日均更新超过50条爆料内容。重大突发事件发生后，最快15分钟内即可发布深度报道，确保吃瓜群众永远走在信息最前沿。',
  },
  {
    q: '如何关注51吃瓜大赛获取最新动态？',
    a: '你可以关注51吃瓜大赛的微信公众号和微博账号，第一时间获取最新爆料推送。同时建议收藏本页面，每天刷新不错过任何一口热乎瓜。',
  },
];

export default function SectionFaq() {
  return (
    <section id="faq" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于51吃瓜大赛你想知道的一切都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2">
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}